export default "__VITE_ASSET__3e38d512__"